import React from 'react';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const ChatSubscriber = React.lazy(() => import('@views/chat/components/ChatSubscriber'));
const ChatInitializer = React.lazy(() => import('@views/chat/components/ChatInitializer'));
const FloatingChat = React.lazy(() => import('@views/chat/components/floating-chat/FloatingChat'));

export default function LazyChatProvider(props: {
    children: React.ReactNode,
}) {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <ChatInitializer>
            <ChatSubscriber>
                {props.children}

                <FloatingChat/>
            </ChatSubscriber>
        </ChatInitializer>
    </React.Suspense>;
}
